import { MapElementWithSectorId } from '@/models/map'

export const normalizeSpot = (spot: MapElementWithSectorId) => ({
  name: spot.name,
  subType: spot.subType,
})
